<template>
  <BCard class="w100 padding-horizontal-big padding-vertical-big margin-bottom-tiny">
    <p class="font-size-big semi-bold margin-top-0 ink-base margin-bottom-normal">
      Lista de atividades
    </p>

    <div
      class="row margin-vertical-big"
      v-for="(subtask, index) in subTasks"
      :key="index"
    >
      <div class="col-md-9 col-8 margin-vertical-tiny">
        <BCheckbox
          :name="`subtask-${index}`"
          v-model="subTasks[index].done"
          :label="subtask.title"
          labelClasses="font-size-big ink-base"
        />
      </div>

      <div class="col-md-3 col-4 display-flex justify-content-end">
        <template v-for="(assign, index) in subtask.assigns">
          <BAvatar
            :key="index"
            class="avatar margin-horizontal-xtiny"
			:name="assign.name"
            :avatarUrl="assign.avatar"
          />
        </template>

        <BButton
          link
          @clickOrEnter="editSubtask(subtask, index)"
        >
          <BIcon>
            <BCreateIcon class="ink-lighter-1 font-size-huge" />
          </BIcon>
        </BButton>
        <BButton
          link
          @clickOrEnter="removeSubtask(index)"
        >
          <BIcon>
            <BDeleteIcon class="red-base font-size-huge" />
          </BIcon>
        </BButton>
      </div>
    </div>

    <div class="row">
      <div class="col-md-6 col-12">
        <BInput
          class="padding-right-normal margin-vertical-normal"
          type="text"
          placeholder="Adicione aqui uma atividade"
          name="subtaskTitleInput"
          v-model="subtaskTitleInput"
        />
      </div>
      <div class="col-md-4 col-12">
        <BSelect
          class="padding-right-normal margin-vertical-normal"
          name="subtaskResponsableSelect"
          placeholder="Selecione"
          v-model="subtaskResponsableSelect"
          :options="availableResponsables"
        />
      </div>
      <div class="col-md-2 col-12">
        <BButton
          outline
          class="font-size-big margin-vertical-normal"
          @clickOrEnter="addOrUpdateNewSubtask"
        >
          <span v-if="subtaskToEditIndex">
            Salvar
          </span>
          <span v-else>
            Adicionar
          </span>
        </BButton>
      </div>
    </div>
  </BCard>
</template>

<script>
import {
	BCard,
	BInput,
	BCheckbox,
	BIcon,
	BCreateIcon,
	BDeleteIcon,
	BSelect,
	BAvatar,
	BButton
} from '@bossabox-code/design-system';

export default {
	name: 'SubTaskFields',
	components: {
		BCard,
		BInput,
		BCheckbox,
		BIcon,
		BCreateIcon,
		BDeleteIcon,
		BSelect,
		BAvatar,
		BButton
	},
	props: {
		subTasks: {
			type: Array,
			required: true,
			default: () => []
		},
		assignUsers: {
			type: Array,
			default: () => []
		}
	},
	mounted() {
		if (this.assignUsers && this.assignUsers.length > 0) {
			this.availableResponsables = this.assignUsers.map(user => ({
				value: user.authId,
				name: user.name
			}));
		}
	},
	data() {
		return {
			subtaskTitleInput: null,
			subtaskResponsableSelect: '',
			availableResponsables: [],
			subtaskToEditIndex: null
		};
	},
	methods: {
		addOrUpdateNewSubtask() {
			if (!this.subtaskTitleInput) {
				return false;
			}

			const assignUser =
				this.subtaskResponsableSelect &&
				this.assignUsers.find(user => user.authId == this.subtaskResponsableSelect.value);

			const subtask = {
				title: this.subtaskTitleInput,
				assigns: assignUser ? [assignUser] : []
			};

			if (this.subtaskToEditIndex) {
				const realIndex = this.subtaskToEditIndex - 1;
				this.subTasks[realIndex] = {
					...this.subTasks[realIndex],
					...subtask
				};
				this.subtaskToEditIndex = null;
			} else {
				this.subTasks.push({
					...subtask,
					done: false
				});
			}

			this.subtaskTitleInput = null;
			this.subtaskResponsableSelect = '';
			this.$emit('updated', this.subTasks);
		},
		editSubtask(subtask, index) {
			this.subtaskToEditIndex = index + 1;
			this.subtaskTitleInput = subtask.title;

			const [assignedUser] = subtask.assigns;
			if (assignedUser) {
				this.subtaskResponsableSelect = {
					value: assignedUser.authId,
					name: assignedUser.name
				};
			}
		},
		removeSubtask(subtaskIndex) {
			this.subTasks = this.subTasks.filter((_, index) => index != subtaskIndex);

			this.$emit('updated', this.subTasks);
		}
	}
};
</script>